import { useEffect } from 'react';
import { useGroup } from '../contexts/GroupContext';
import { isNonEmptySubawardeeId } from '../utils/adminSubawardeeUtils';
import type { AdminMilestoneView } from '../stores/adminMilestoneViewStore';

/**
 * Aligns `selectedGroup` with the active subawardee milestones view for API requests.
 * Component-project milestones are scoped by URL + `X-Admin-Scope: all` instead.
 */
export function useSyncSelectedGroupForMilestoneView(
  view: AdminMilestoneView,
  _componentProjectId: string | null,
  subawardee: string | null
): void {
  const { setSelectedGroup, isGroupAccessible } = useGroup();

  useEffect(() => {
    if (view === 'component') return;
    if (!isNonEmptySubawardeeId(subawardee)) return;
    if (!isGroupAccessible(subawardee)) return;
    setSelectedGroup(subawardee);
  }, [view, subawardee, setSelectedGroup, isGroupAccessible]);
}
